import { FC, memo } from 'react';
import './style.scss';
import moment from 'moment';
import { IFoodicsLog } from '../../store/foodicsLogStore';
import { FOODICS_LOG_COLUMN } from '../../constants/foodicsLogRow';
import Label from '~/view/components/Controls/Label';
import { COLORS } from '~/constants/styles';
import { localeStore } from '~/mobx/localesStore';

const getBusinessDateFormat = (date: string | null): string => {
  if (date === null) {
    return '-';
  }

  return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY, h:mm:ss A');
};

const getDailySync = (dailySync: number) => {
  if (dailySync === 1) {
    return <Label color={COLORS.MAINBLUE} text={localeStore.t('enabled')} className="text-size-12" />;
  }

  return <Label color={COLORS.RED} text={localeStore.t('disabled')} className="text-size-12" />;
};

const getCellText = (txt: any): string => {
  if (!txt) {
    return '-';
  }

  return txt;
};

interface IProps {
  foodicsLog?: IFoodicsLog;
}

const FoodicsLogListRow: FC<IProps> = ({ foodicsLog }: IProps): JSX.Element | null => {
  if (!foodicsLog) {
    return null;
  }

  const defaultClassesWithoutElipsis = 'family-medium text-size-16';
  const defaultClassesWithElipsis = 'family-medium text-size-16 text-elipsis';

  const time = getBusinessDateFormat(foodicsLog.created_at);
  const user = getCellText(foodicsLog.userName);
  const action = getCellText(foodicsLog.actionName);
  const sync_data = getCellText(foodicsLog.syncDataText);
  const sync_from = getCellText(foodicsLog.synced_from);
  const daily_sync = getDailySync(foodicsLog.daily_sync);

  return (
    <div className="foodics-log-list">
      <div className={`cell cell-${FOODICS_LOG_COLUMN.TIME}`}>
        <p className={defaultClassesWithElipsis}>{time}</p>
      </div>

      <div className={`cell cell-${FOODICS_LOG_COLUMN.USER}`}>
        <p className={defaultClassesWithElipsis}>{user}</p>
      </div>

      <div className={`cell cell-${FOODICS_LOG_COLUMN.ACTION}`}>
        <p className={defaultClassesWithElipsis}>{action}</p>
      </div>

      <div className={`cell cell-${FOODICS_LOG_COLUMN.SYNC_DATA}`}>
        <p className={defaultClassesWithoutElipsis}>{sync_data}</p>
      </div>

      <div className={`cell cell-${FOODICS_LOG_COLUMN.SYNC_FROM}`}>
        <p className={defaultClassesWithElipsis}>{sync_from}</p>
      </div>

      <div className={`cell cell-${FOODICS_LOG_COLUMN.DAILY_SYNC}`}>{daily_sync}</div>
    </div>
  );
};

export default memo(FoodicsLogListRow);
